<ng-content [select]="'lumiron-section-header'"></ng-content>
<ng-content [select]="'lumiron-section-body'"></ng-content>
@if (backgroundImage(); as image) {
<img [ngSrc]="image" fill placeholder alt="" />
}
